<template>
  <router-view />
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
.active-tab {
  color: #00903a;
  cursor: pointer;
  font-size: 13px;
}
.inactive-tab {
  color: #9299a8;
  font-size: 13px;
  cursor: pointer;
}

.border-right-div {
  border-left: 0.5px solid #f3f4f5;
  height: 50px;
}

.border-tab-active {
  background-color: #00903a;
  border: 1px solid #00903a;
  width: 100%;
  cursor: pointer;
  font-size: 12px;
}

.field-input[data-v-f5832120] {
  cursor: pointer !important;
  background-color: #fff !important;
  -webkit-transition-duration: 0.3s !important;
  transition-duration: 0.3s !important;
  position: relative !important;
  width: 100% !important;
  height: 30px !important;
  min-height: 39.4px !important;
  padding-left: 12px !important;
  padding-right: 44px !important;
  font-weight: 400 !important;
  -webkit-appearance: none !important;
  outline: none !important;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  border-radius: 4px !important;
  font-size: 14px !important;
  z-index: 0 !important;
}

@media (max-width: 768px) {
  .border-right-div {
  border-left:none;
  height: 20px;
}
}
</style>
